export default (...args) => {
  try {
    return new RegExp(...args);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(e);
    return undefined;
  }
};
